import React from "react";

const BarcodeModals = ({
  barcodeModalOpen,
  setBarcodeModalOpen,
  selectedItem,
  barcodeValue,
  setBarcodeValue,
  handleBarcodeSubmit,
  bulkBarcodeModal,
  setBulkBarcodeModal,
  handleCreateBarcode,
}) => {
  return (
    <>

      {/* update Barcode modal */}
      {barcodeModalOpen && selectedItem && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white w-[400px] rounded-xl p-6 relative montserrat-font-1">
            <button
              onClick={() => setBarcodeModalOpen(false)}
              className="absolute right-4 top-4 text-gray-500"
            >
              ✕
            </button>

            <h2 className="text-2xl font-semibold text-center mb-4 mt-5 text-gray-800">
              Add Barcode to {selectedItem.item_name}
            </h2>

            <div className="flex flex-col items-center mb-4">
              <img
                src={selectedItem.photo}
                className="w-16 h-16 rounded object-cover"
              />

              <div className="text-sm text-gray-500 mt-1">
                {selectedItem.category_name}
              </div>
            </div>

            <div className="bg-gray-100 text-center text-sm rounded-lg px-3 py-2 mb-3">
              Assigned barcode: {selectedItem.barcodeNumber || "—"}
            </div>

            <input
              autoFocus
              value={barcodeValue}
              onChange={(e) => setBarcodeValue(e.target.value)}
              className="w-full border rounded-lg px-4 py-3 text-center mb-4"
            />

            <button
              onClick={handleBarcodeSubmit}
              className="w-full bg-emerald-500 hover:bg-emerald-600 text-white py-3 rounded-lg"
            >
              Submit
            </button>
          </div>
        </div>
      )}

      {/* Update barcode conformation model  */}

      {bulkBarcodeModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
          <div className="bg-white w-[420px] rounded-xl shadow-lg p-6">
            {/* TITLE */}

            <h2 className="text-lg font-semibold text-gray-800 mb-2">
              Are you sure?
            </h2>

            {/* MESSAGE */}

            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to create barcodes for all items?
            </p>

            {/* BUTTONS */}

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setBulkBarcodeModal(false)}
                className="border px-4 py-2 rounded-lg text-sm hover:bg-gray-100"
              >
                Cancel
              </button>

              <button
                onClick={handleCreateBarcode}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm"
              >
                Yes, Create
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BarcodeModals;
